import { Box, styled, Typography } from "@mui/material";
import theme from "../theme";
import ProgressLoader from "../loader/ProgressLoader";

export const LabRequistionTemplateForm = styled(Box)`
  .MuiGrid-direction-xs-row {
    flex: 1;
  }

  .MuiGrid-direction-xs-row {
    & > .MuiGrid-direction-xs-column {
      & > .MuiGrid-direction-xs-row {
        margin-bottom: 8px;
      }
    }
  }
`;

export const EmptyFormErrorText = styled(Typography)`
  font-size: 14px;
  margin-bottom: 16px;
  font-weight: 500;
  color: ${theme.palette.error.main};
`;

export const Loader = styled(ProgressLoader)`
  margin-top: 10px;
  height: auto;
`;
